import React from "react"

import ControlButtonStandard from "../../../../../buttons/control-button/control-button-standard"
import {LexicalEditor} from "lexical"

const NORMAL_HEADING_VALUE = 'custom-paragraph'

type Props = {
    menuParams  : {
        options     : any[]
        editor      : LexicalEditor
        blockType   : any
    }
    showPopover : boolean
    isMinimized : boolean
    hidePopover : callback
}

export default function ToolbarHeadingButton(props: Props) {
    const {blockType, options} = props.menuParams

    let option: any
    _.some(options, o=>{
        if (o.options) {
            option = _.find(o.options, option=>option.value === blockType)
        } else if (o.value === blockType) {
            option = o
        }

        return !!option
    })

    if (!option) {
        option = _.find(options, o=>o.value === NORMAL_HEADING_VALUE)
    }

    const classes = Classes("heading-button p-l-8 p-r-8 w-100-percent", {
        'show-popover': props.showPopover,
    })

    return (
        <ControlButtonStandard className={classes}>
            <div className="flex-row-left-center txt-truncate">
                {option.icon && <div className={Classes("ui5-ico-16", option.icon)}/>}
                {option.iconComponent}
                {!props.isMinimized &&
                    <div className="ui5-txt-not-important-small lh-16 no-wrap m-l-5 txt-truncate">{option.label}</div>}
            </div>
            <div className="ui5-triangle-toggle s6 open m-l-5 m-t-3"/>
        </ControlButtonStandard>
    )
}